<template>
    <div class="sm-admin-mail sm-flex-1 sm-flex sm-flex-column">
    <div class="sm-flex sm-flex-1">
      <div class="sm-admin-mail__left">
        <div class="sm-admin-mail__left-inner" ref="notifs" :style="{ height: height , top: marginTop , transition: 'margin 0.2s ease' }">
          <div class="sm-admin-mail__left-content">
            <div class="sm-admin-mail__left-tabs">
              <a
                v-for="item in tabs"
                :key="item.tab"
                :class="{
                  'active': item.tab == currentTab || item.hover
                }"
                @mouseenter="showHint(item, $event)"
                @mouseleave="hideHint"
                @click.prevent="switchTab(item.tab)"
                style="position: relative;"
              >
  
              <include-svg :name="item.tab == currentTab || item.hover ? item.iconActive : item.icon" />
                
              </a>
            </div>
            <div class="sm-admin-mail__left-requests">
              <action-requests 
                v-if="Object.keys(summary).some(key => summary[key]) && !$route.query.account_id"
                :requests="summary"
                @action="handleRequest"
  
                @showHint="showHint"
                @hideHint="hideHint"
              />
            </div>
          </div>
        </div>
      <!-- <div class="scrolling-indicate"></div> -->  
      </div>
      <div class="sm-admin-mail__main sm-overflow-hidden">
        <mail-top />
        <mail-list 
          @summary="handleSummary"
        />
      </div>
    </div>

    <div
      v-for="hint in visibleHints"
      :key="hint.key"
      class="sm-hint horizontal"
      :style="{ top: hint.position.top + 'px', left: hint.position.left + 'px' }"
    >
      <div class="sm-hint__content">{{ hint.text }}</div>
    </div>
    <!-- <christmas-promotion></christmas-promotion> -->
  </div>
</template>

<script>
import Top from '@/views/admin/pages/mail/Top.vue';
import List from '@/views/admin/pages/mail/List.vue';
import ActionRequests from '@/components/mail/ActionRequests';
import HintWrap from '@/components/HintWrap';
import { mapActions } from 'vuex';
// import ChristmasPromotion from '@/components/ChristmasPromotion.vue';

export default {
  name: 'mail',
  components: {
    'mail-top': Top,
    'mail-list': List,
    'action-requests': ActionRequests,
    'hint-wrap': HintWrap,
    // 'christmas-promotion': ChristmasPromotion
  },
  data() {
    return {
      tabs: [{
        tab: 'single',
        text: 'Mail Center',
        icon: 'icon-mail-single',
        iconActive: 'icon-mail-single-active',
        hover: false
      },
      {
        tab: 'group',
        text: 'Bulk Shipping',
        icon: 'icon-mail-group',
        iconActive: 'icon-mail-group-active',
        hover: false
      }],
      summary: {},
      height: '100vh',
      marginTop: "0",
      visibleHints: [],
      footerObserver: null,
      headerObserver: null,
      footerVisibleHeight: 0,
      headerVisibleHeight: 0,
    }
  },
  computed: {
    currentTab() {
      if (this.$route.query.shortcut)
        return null;

      return this.$route.query.tab || 'single';
    }
  },
  created() {
    if(this.$route.query.tab === 'group') {
      this.getAdminList()
        .then(res => {
          this.handleSummary(res.summary);
        });
    }
  },
  mounted() {
    this.calculateHeight();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.calculateHeight);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.calculateHeight);
  },
  methods: {
    ...mapActions({
      'getAdminList': 'mail/getAdminList'
    }),
    handleSummary(data) {
      this.summary = data;
    },
    handleRequest(name) {
      if (name)
        this.$router.push({
          query: {
            shortcut: name
          }
        });
      else
        this.$router.push({
          query: {}
        });
    },
    switchTab(tab) {
      this.$router.push({
        query: {
          tab
        }
      });
    },
    handleScroll() {
      window.requestAnimationFrame(this.calculateHeight);
    },
    // Update content height and sidebar top
    updateContentHeight() {
        this.height = `calc(100vh - ${this.headerVisibleHeight}px - ${this.footerVisibleHeight}px)`;
        return this.height;
    },
    calculateHeight() {
      const header = document.querySelector('.sm-header'); // Adjust selector as needed
      const footer = document.querySelector('footer'); // Adjust selector as needed
      const threshold = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
      // Observe header
      this.headerObserver = new IntersectionObserver(
        ([entry]) => {
          const rect = entry.boundingClientRect;
          const viewportHeight = window.innerHeight;
          if (entry.isIntersecting) {
            const visibleTop = Math.max(rect.top, 0);
            const visibleBottom = Math.min(rect.bottom, viewportHeight);
            this.headerVisibleHeight = Math.max(0, visibleBottom - visibleTop);
          } else {
            this.headerVisibleHeight = 0;
          }
          this.marginTop = `${this.headerVisibleHeight}px`;
          this.updateContentHeight();
        },
        { root: null, threshold }
      );
      this.headerObserver.observe(header);

      // Observe footer
      this.footerObserver = new IntersectionObserver(
        ([entry]) => {
          const rect = entry.boundingClientRect;
          const viewportHeight = window.innerHeight;
          if (entry.isIntersecting) {
            const visibleTop = Math.max(rect.top, 0);
            const visibleBottom = Math.min(rect.bottom, viewportHeight);
            this.footerVisibleHeight = Math.max(0, visibleBottom - visibleTop);
          } else {
            this.footerVisibleHeight = 0;
          }
          this.updateContentHeight();
        },
        { root: null, threshold }
      );
      this.footerObserver.observe(footer);
    },

    showHint(item, event) {
    // Use currentTarget to get the <a> element
    const linkElement = event.currentTarget;
    const rect = linkElement.getBoundingClientRect();
    
    // Calculate the vertical center of the link
    const verticalCenter = rect.top + (rect.height / 2);
    
    // Get the sidebar's left offset to properly position the hint
    const sidebar = document.querySelector('.sm-admin-mail__left');
    const sidebarRect = sidebar.getBoundingClientRect();
    
    const hint = {
      key: item.tab,
      text: item.text,
      position: {
        // Center the hint vertically with the icon
        top: verticalCenter,
        // Position hint to the right of the sidebar
        left: sidebarRect.right + 8, // 8px gap
        },
      };
      
      this.visibleHints = [hint];
    },
    hideHint() {
      this.visibleHints = []; // Clear all visible hints
    },

  }
};
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  
  .sm-admin-mail {
    position: relative;
    max-width: 100%;
    overflow: hidden;

    &__main {
      position: relative;
      z-index: 1;
      flex: 1;
    }

    &__left{
      position: relative;
      min-width: 70px;
      width: 70px;
      @include media('<=tiny') {
        min-width: 50px;
        width: 50px;
      }
      &-inner {
        position: fixed;
        overflow: hidden;
        top: 0;
        left: 0;
        width: inherit;
        background-color: var(--white);
        border-right: 1px solid var(--grey-line);
        z-index: 2;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 70px;
          height: 50px;
          z-index: 5;
          background: linear-gradient(to top, rgba(245,245,245,1) 20%,rgba(250,250,250,0.7) 50%, rgba(250,250,250,0));
        }
        @include media('<=tiny') {
          width: 50px;
        }
      }
      &-content {
        // Method 1: Using opacity transition
        overflow-y: auto;
        max-height: 100%;
        &::-webkit-scrollbar {
          width: 3px;
          opacity: 0;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: rgba(170, 170, 170, 0); // Start transparent
          border-radius: 20px;
          transition: background-color 0.3s ease; // Transition the background-color
        }

        &::-webkit-scrollbar-track-piece:end {
          background: transparent;
          margin-bottom: 10px; 
        }

        &::-webkit-scrollbar-track-piece:start {
          background: transparent;
          margin-top: 10px;
        }

        &:hover {
          &::-webkit-scrollbar-thumb {
            background-color: rgba(170, 170, 170, 1); // Fade to visible
          }
        }
      }


      &-tabs {
        padding-top: 44px;
        display: flex;
        flex-direction: column;
        align-items: center;
        & > a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 48px;
          height: 48px;
          color: var(--sys);
          border-radius: 10px;
          cursor: pointer;

          @include media('<=tiny') {
            width: 40px;
            height: 40px;
          }

          &:not(:first-child) {
            margin-top: 12px;
          }

          &.active {
            background-color: var(--sys-bg);
          }
        }
      }

      &-requests {
        position: relative;
        margin-top: 50px;
        padding-bottom: 44px;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: -30px;
          width: 44px;
          height: 2px;
          margin: 0 auto;
          background-color: var(--grey-add);
          border-radius: 2px;
          opacity: 0.4;
        }
      }
    }
  }

.sm-admin-mail > .sm-hint {
  position: fixed;
  z-index: 10000;
  // pointer-events: none;
  transform: translateY(-50%); // Center vertically 
}

// .scrolling-indicate {
//     position: fixed;
//     bottom: 0;
//     height: 44px;
//     background: linear-gradient(180deg, rgba(255, 255, 255, 0) -11.27%, rgba(255, 255, 255, 0.706999) 33.33%, #FFFFFF 80.24%);

//   }



</style>